import { SearchBoxImageResizeMode } from './SearchBox.types';

export const DEFAULT_IMAGE_RESIZE_MODE: SearchBoxImageResizeMode = 'crop';
